import React, { useState } from 'react';
import { DaviviendaMortgageIcon, ChevronRightIcon, XMarkIcon } from '../Icons';

export const ReferralBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState(true);

    const handleNavigate = () => {
        window.open(`${window.location.origin}/#/referido-credito`, '_blank');
    };

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="hidden md:block fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pointer-events-none">
            <div className="max-w-4xl mx-auto pointer-events-auto relative">
                {/* Close Button X (Placed as a sibling to avoid any nested click bubbling issues) */}
                <button
                    onClick={handleClose}
                    className="absolute top-3 right-3 p-1.5 rounded-full bg-white/10 hover:bg-white/35 active:bg-white/40 text-white transition-all active:scale-90 z-20 shadow-sm"
                    aria-label="Cerrar banner"
                    id="close-referral-banner-btn"
                >
                    <XMarkIcon className="w-4 h-4" />
                </button>

                <div 
                    onClick={handleNavigate}
                    className="w-full bg-[#0073b7] rounded-2xl shadow-2xl p-4 flex items-center justify-between cursor-pointer transform transition-all hover:scale-[1.01] active:scale-[0.99] border border-white/10 group overflow-hidden"
                >
                    {/* Background Decor */}
                    <div className="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-2xl group-hover:bg-white/20 transition-colors"></div>
                    
                    <div className="flex items-center gap-4 relative z-10 pr-10">
                        <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center text-white backdrop-blur-sm shrink-0">
                            <DaviviendaMortgageIcon className="w-8 h-8" />
                        </div>
                        <div>
                            <h4 className="text-white font-black text-xs sm:text-sm uppercase tracking-tight leading-tight">
                                Gestionamos el crédito para tu cliente
                            </h4>
                            <p className="text-sky-100 text-[11px] sm:text-xs font-bold mt-1">
                                ¡Refiere y gana el <span className="text-yellow-400 text-sm">0,4%</span> por cada desembolso!
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-3 relative z-10 shrink-0">
                        <button className="bg-[#ffb703] text-[#00234F] px-4 py-2 sm:px-5 sm:py-2.5 rounded-xl font-black text-[10px] sm:text-xs uppercase tracking-widest shadow-lg flex items-center gap-2 group-hover:bg-white transition-all">
                            Referir
                            <ChevronRightIcon className="w-4 h-4" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};